var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { LitElement, css, html } from "lit";
import { customElement, property } from "lit/decorators.js";
import { qboui } from "./styles.js";
export var Mode;
(function (Mode) {
    Mode["Single"] = "single";
    Mode["Multi"] = "multi";
})(Mode || (Mode = {}));
let QboSelectable = class QboSelectable extends LitElement {
    constructor() {
        super(...arguments);
        this.classSelected = 'qbo-select-on';
        this.classUnselected = 'qbo-select-off';
        this.selector = '*[data-selectable]';
        this.parent = null;
        this.type = null;
        this.selected = false;
        this.mode = Mode.Single;
        this.toggleCheckbox = true;
        this.selectedItems = [];
        this.target = null;
        this._previousItem = null;
    }
    static { this.styles = [
        qboui,
        css ``
    ]; }
    // Deselected all items.
    clear() {
        const items = this.getItems();
        items?.forEach(item => {
            this.setItem(item, false);
        });
    }
    toggleAll() {
        this.selected = !this.selected;
        const items = this.getItems();
        items?.forEach(item => {
            this.setItem(item, this.selected);
        });
        this.dispatchSelectionEvent();
    }
    render() {
        return html `<slot @click=${this.toggleAll}><qbo-icon .type="${this.type}" icon="${this.selected ? 'check-square' : 'square'}" /></slot>`;
    }
    connectedCallback() {
        super.connectedCallback();
        if (this.parent) {
            this.target = this.closest(this.parent);
            if (this.target == null)
                console.warn(`Parent ${this.parent} not found`);
        }
        this.target ??= this;
        this.target.addEventListener('click', this.itemClick.bind(this));
    }
    disconnectedCallback() {
        this.target?.removeEventListener('click', this.itemClick);
        super.disconnectedCallback();
    }
    getItems() {
        return Array.from(this.target?.querySelectorAll(this.selector) || []);
    }
    itemClick(e) {
        const source = e.target;
        const item = source.matches(this.selector) ? source : source.closest(this.selector);
        if (!item || !this.target?.contains(item))
            return;
        const event = e;
        if (this.mode === Mode.Single && !event.shiftKey && !event.ctrlKey && this._previousItem && this._previousItem !== item)
            this.setItem(this._previousItem, false);
        //const selected = (item === this._previousItem && this.mode === Mode.Single)
        //    ? this.setItem(item, item.classList.contains(this.classSelected))
        //    : this.setItem(item);
        const selected = this.setItem(item);
        if (event.shiftKey && this._previousItem) {
            const items = this.getItems();
            let inRange = false;
            items.forEach(el => {
                if (el === item || el === this._previousItem)
                    inRange = !inRange;
                if (inRange)
                    this.setItem(el, selected);
            });
            window.getSelection()?.removeAllRanges();
        }
        this._previousItem = item;
        this.dispatchSelectionEvent();
    }
    setItem(item, selected = null) {
        if (selected === null) {
            selected = !item.classList.contains(this.classSelected);
        }
        item.classList.toggle(this.classSelected, selected);
        item.classList.toggle(this.classUnselected, !selected);
        if (this.toggleCheckbox) {
            const checkbox = item instanceof HTMLInputElement && item.type === 'checkbox'
                ? item
                : item.querySelector('input[type=checkbox]');
            if (checkbox)
                checkbox.checked = selected;
        }
        const index = this.selectedItems.indexOf(item);
        if (selected && index === -1) {
            this.selectedItems.push(item);
        }
        else if (!selected && index !== -1) {
            this.selectedItems.splice(index, 1);
        }
        return selected;
    }
    dispatchSelectionEvent() {
        const selectedItemValues = this.selectedItems.map(item => item.dataset.selectable);
        const event = new CustomEvent('change', {
            detail: {
                items: this.selectedItems,
                values: selectedItemValues
            },
            bubbles: true,
            composed: true
        });
        this.dispatchEvent(event);
    }
};
__decorate([
    property(),
    __metadata("design:type", String)
], QboSelectable.prototype, "classSelected", void 0);
__decorate([
    property({ type: String }),
    __metadata("design:type", Object)
], QboSelectable.prototype, "classUnselected", void 0);
__decorate([
    property({ type: String }),
    __metadata("design:type", Object)
], QboSelectable.prototype, "selector", void 0);
__decorate([
    property({ type: String }),
    __metadata("design:type", Object)
], QboSelectable.prototype, "parent", void 0);
__decorate([
    property(),
    __metadata("design:type", Object)
], QboSelectable.prototype, "type", void 0);
__decorate([
    property({ type: Boolean }),
    __metadata("design:type", Object)
], QboSelectable.prototype, "selected", void 0);
__decorate([
    property({ type: Mode }),
    __metadata("design:type", Object)
], QboSelectable.prototype, "mode", void 0);
__decorate([
    property(),
    __metadata("design:type", Boolean)
], QboSelectable.prototype, "toggleCheckbox", void 0);
__decorate([
    property({ attribute: false }),
    __metadata("design:type", Object)
], QboSelectable.prototype, "target", void 0);
QboSelectable = __decorate([
    customElement('qbo-selectable')
], QboSelectable);
export { QboSelectable };
